import { businessAddress, formatDate, fullName } from '../../utils/getPostRole'

export const businessExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{ label: 'Name', render: p => fullName(p) },
	{ label: 'Mobile', render: p => p?.mobile || '' },
	{ label: 'Firm Name', render: p => p?.businessFirmName || '' },
	{ label: 'Industry', render: p => p?.businessIndustry || '' },
	{ label: 'Services', render: p => p?.businessServices || '' },
	{ label: 'Category', render: p => p?.businessCategory || '' },
	{ label: 'Contact No', render: p => p?.businessContactNo || '' },
	{ label: 'Website / UPI', render: p => p?.businessUPIWebsite || '' },
	{ label: 'Business Address', render: p => businessAddress(p) },
	{ label: 'Created Date', render: p => formatDate(p?.createdAt) },
]
